import React, { useState } from 'react'
import BottomSheet from '@components/BottomSheet'
import { ContactList } from '@components/ContactList/ContactList'
import { useContacts } from '@plug-core/state'
import ContactForm from '@modules/ContactForm'
import { Button, Stack } from '@mui/material'
import { HiUserAdd } from 'react-icons/hi'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@utils/routes'

export const Contacts = () => {
  const { contacts } = useContacts()
  const [contactModalVisible, setContactModalVisible] = useState(false)
  const [selectedAddress, setSelectedAddress] = useState<string | null>(null)
  const navigate = useNavigate()
  const { t } = useTranslation()

  const closeContactForm = () => {
    setContactModalVisible(false)
    setSelectedAddress(null)
  }

  const navigateToContact = ({ address }: { address: string }) => {
    navigate(ROUTES.CONTACT_DETAILS(address), { state: { address } })
  }

  return (
    <Stack spacing={2} px={2}>
      <ContactList
        contactSections={[{ kind: 'contacts', contacts }]}
        onContactClick={navigateToContact}
      />
      <Button onClick={() => setContactModalVisible(true)} startIcon={<HiUserAdd />}>
        {t('contacts.addNew')}
      </Button>
      <BottomSheet visible={contactModalVisible} onBackdropClick={closeContactForm}>
        <ContactForm
          address={selectedAddress || ''}
          close={closeContactForm}
          onSave={(address) => navigateToContact({ address })}
        />
      </BottomSheet>
    </Stack>
  )
}
